import * as React from "react";
import { isWordLicenseBlocked, type WordLicenseFields } from "@/utils/runtime-env";
import { debugLog } from "@/utils/debug";

export enum AuthenticatedScreenTabs {
  REVIEW = "review",
  DISCUSS = "discuss",
  RESEARCH = "research",
}

export const useAuthenticatedTabs = () => {
  const [selectedTab, setSelectedTab] = React.useState(AuthenticatedScreenTabs.DISCUSS);
  const [hasUnreadDiscuss, setHasUnreadDiscuss] = React.useState(false);
  const [hasUnreadResearch, setHasUnreadResearch] = React.useState(false);
  const [hasUnreadReview, setHasUnreadReview] = React.useState(false);
  const selectedTabRef = React.useRef(selectedTab);

  React.useEffect(() => {
    selectedTabRef.current = selectedTab;
  }, [selectedTab]);

  const handleTabChange = (value: string) => {
    setSelectedTab(value as AuthenticatedScreenTabs);
    if (value === AuthenticatedScreenTabs.DISCUSS) setHasUnreadDiscuss(false);
    if (value === AuthenticatedScreenTabs.RESEARCH) setHasUnreadResearch(false);
    if (value === AuthenticatedScreenTabs.REVIEW) setHasUnreadReview(false);
  };

  return {
    selectedTab,
    hasUnreadDiscuss,
    hasUnreadResearch,
    hasUnreadReview,
    handleTabChange,
    handleNewMessage: () => {
      if (selectedTabRef.current !== AuthenticatedScreenTabs.DISCUSS) setHasUnreadDiscuss(true);
    },
    handleResearchNewMessage: () => {
      if (selectedTabRef.current !== AuthenticatedScreenTabs.RESEARCH) setHasUnreadResearch(true);
    },
    handleReviewComplete: () => {
      if (selectedTabRef.current !== AuthenticatedScreenTabs.REVIEW) setHasUnreadReview(true);
    },
  };
};

export const usePaneLicenseGate = (
  subscription: WordLicenseFields | undefined,
  isDocumentForbidden: boolean,
  documentId: string | undefined
) => {
  const isUnlicensed = isWordLicenseBlocked(subscription);
  React.useEffect(() => {
    debugLog("license", "pane gate", {
      isMsWordLicense: subscription?.is_ms_word_license ?? subscription?.isMsWordLicense ?? null,
      isUnlicensed,
      isDocumentForbidden,
      documentId: documentId ?? null,
    });
  }, [
    subscription?.is_ms_word_license,
    subscription?.isMsWordLicense,
    isUnlicensed,
    isDocumentForbidden,
    documentId,
  ]);
  return { isUnlicensed, isDisabled: isUnlicensed || isDocumentForbidden };
};
